import React, { FC, ReactNode } from 'react';

export type ProductBannerWrapperProps = {
  children: ReactNode;
  className?: string;
  bgColor?: string;
};

const ProductBannerWrapper: FC<ProductBannerWrapperProps> = ({ children, bgColor, className='' }) => {
  return (
    <div
      className={`relative ${className}`}
      style={{ backgroundColor: bgColor }}
      data-testid='product-banner-wrapper'
    >
      {children}
    </div>
  );
};

export default ProductBannerWrapper;
